import { AGENT_ORGANISATION_IDS, RESELLER_ORGANISATION_IDS, OPEN_ACCESS_ORGANIZATION_ID } from './config';

export const ORGANISATION_TYPE = {
    METSERVICE: 'MetService',
    RESELLER: 'Reseller',
    OPEN_ACCESS: 'Open Access',
    BASIC: 'Basic',
};

export const ORGANISATION_TYPE_IDS = {
    [ORGANISATION_TYPE.METSERVICE]: AGENT_ORGANISATION_IDS,
    [ORGANISATION_TYPE.RESELLER]: RESELLER_ORGANISATION_IDS,
    [ORGANISATION_TYPE.OPEN_ACCESS]: OPEN_ACCESS_ORGANIZATION_ID,
};

export const USER_TYPE = {
    ADMIN: 'Admin',
    RESELLER: 'Reseller',
    BASIC: 'Basic',
};
